// dependencies
import { fromJS } from "immutable";

const UIState = fromJS({
	goalName: "",
	goalsList: [],
});

export default UIState;
